/*
  PDP redesign (Figma "Mobile PDP: proposed hierarchy").
  - Price / compare / "Save x%" in the top block follow the selected variant
  - Size buttons show which sizes are sold out in the selected colour
  - Gallery: labelled thumbnail strip under the slider (mobile) + badge on the image
  - Mobile: the slider keeps ALL photos; picking a colour slides to that colour's first photo
    (desktop keeps the theme's behaviour: only the selected colour's photos are shown)
  Listens to the theme's "variant:changed" event; does not change how the form works.
*/
(function () {
  var dataEl = document.getElementById('jsc-pdp-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var variants = data.variants || [];
  var labels = data.galleryLabels || [];

  function byId(id) {
    id = Number(id);
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return null;
  }

  function initialVariant() {
    var id = null;
    var sel = document.querySelector('.Product__Info form.ProductForm select[name="id"], .Product__Info form.ProductForm [name="id"]');
    if (sel && sel.value) id = sel.value;
    if (!id && window.ShopifyAnalytics && ShopifyAnalytics.meta) id = ShopifyAnalytics.meta.selectedVariantId;
    var u = new URLSearchParams(location.search).get('variant');
    if (u) id = u;
    return byId(id) || variants[0];
  }

  /* ---------- Price row ---------- */
  function updatePrice(v) {
    var head = document.querySelector('[data-jsc-pdp-head]');
    if (!head || !v) return;
    var p = head.querySelector('[data-pdp-price]');
    var c = head.querySelector('[data-pdp-compare]');
    var s = head.querySelector('[data-pdp-save]');
    if (p) p.textContent = v.price;
    if (c) { c.textContent = v.compare || ''; c.hidden = !v.compare; }
    if (s) { s.textContent = 'Save ' + v.save + '%'; s.hidden = !v.save; }
  }

  /* ---------- Sizes sold out in the selected colour ---------- */
  function updateSizes(v) {
    if (!v) return;
    document.querySelectorAll('.Product__Info .SizeSwatchList .SizeSwatch__Radio').forEach(function (input) {
      var idx = (parseInt(input.getAttribute('data-option-position'), 10) || 1) - 1;
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options, ok = o[idx] === input.value;
        for (var j = 0; ok && j < o.length; j++) if (j !== idx && o[j] !== v.options[j]) ok = false;
        if (ok) { match = variants[i]; break; }
      }
      var li = input.closest('li') || input.parentNode;
      li.classList.toggle('jsc-size-na', !match || !match.available);
    });
  }

  /* ---------- Badge on the gallery image ----------
     Sits inside the first photo of the selected colour (top-left), so it is always on the image,
     on mobile (slider) and desktop (stacked photos). */
  var currentBadge = '';
  function placeBadge() {
    document.querySelectorAll('.jsc-pdp-img-badge').forEach(function (el) { el.remove(); });
    if (!currentBadge) return;
    var root = document.querySelector('.jsc-product-gallery-new-layout') || document.querySelector('.Product__Gallery');
    if (!root) return;
    var col = selectedColour();
    var first = null, firstVisible = null;
    root.querySelectorAll('.Product__SlideItem').forEach(function (s) {
      if (s.classList.contains('d-none')) return;
      if (!firstVisible) firstVisible = s;
      if (!first && col && s.getAttribute('data-alt') === col) first = s;
    });
    first = first || firstVisible;
    if (!first) return;
    var box = first.querySelector('.AspectRatio') || first;
    var b = document.createElement('span');
    b.className = 'jsc-pdp-img-badge';
    b.textContent = currentBadge;
    box.appendChild(b);
  }
  function updateBadge(v) {
    currentBadge = v && v.badge ? v.badge : '';
    placeBadge();
  }

  function selectedColour() {
    var r = document.querySelector('.Product__Info .ColorSwatch__Radio:checked');
    return r ? r.value : '';
  }

  /* ---------- Thumbnail strip under the mobile slider ---------- */
  var slider = document.querySelector('.jsc-product-gallery-new-layout');
  var strip = null;
  var isMobile = function () { return window.innerWidth < 1009; };

  /* ---------- Mobile gallery: all photos, jump to the selected colour ----------
     The theme's onloadimgswap() (jsc-reset-scripts.js) rebuilds the mobile slider with only the selected
     colour's photos. On mobile we replace it: keep every photo and select the colour's first one.
     On desktop the theme's own function still runs. */
  var allSlides = slider ? Array.prototype.slice.call(slider.querySelectorAll('.Product__SlideItem')) : [];
  function colourIndex(list, col) {
    for (var i = 0; i < list.length; i++) if (list[i].getAttribute('data-alt') === col) return i;
    return 0;
  }
  function mobileGallery() {
    if (!slider || !window.jQuery) return;
    var source = (window.$childArrayElement && window.$childArrayElement.length) ? window.$childArrayElement.toArray() : allSlides;
    if (!source.length) return;
    var col = selectedColour();
    var f = flkty();
    source.forEach(function (s) { s.classList.remove('d-none'); s.classList.add('is-selected'); });
    if (f && f.cells && f.cells.length === source.length) {
      // slider already holds every photo: just slide to the colour
      f.resize();
      f.select(colourIndex(f.cells.map(function (c) { return c.element; }), col));
      return;
    }
    var $c = jQuery(slider);
    try { $c.flickity(); $c.flickity('destroy'); } catch (e) {}
    $c.children('.Product__SlideItem').remove();
    source.forEach(function (s) { slider.appendChild(s); });
    $c.flickity({
      cellAlign: 'left', prevNextButtons: true, pageDots: false, adaptiveHeight: true, dragThreshold: 8,
      initialIndex: colourIndex(source, col)
    });
  }
  var themeSwap = null;
  function swapProxy() {
    if (isMobile()) return mobileGallery();
    if (typeof themeSwap === 'function') return themeSwap.apply(this, arguments);
  }
  if (slider) {
    var existing = window.onloadimgswap;
    if (typeof existing === 'function' && existing !== swapProxy) themeSwap = existing;
    try {
      Object.defineProperty(window, 'onloadimgswap', {
        configurable: true,
        get: function () { return swapProxy; },
        set: function (fn) { if (fn !== swapProxy) themeSwap = fn; }
      });
    } catch (e) {}
  }

  function flkty() {
    if (!slider) return null;
    if (window.Flickity && Flickity.data) { var f = Flickity.data(slider); if (f) return f; }
    if (window.jQuery) { var j = jQuery(slider).data('flickity'); if (j) return j; }
    return null;
  }

  function slides() {
    if (!slider) return [];
    return Array.prototype.filter.call(slider.querySelectorAll('.Product__SlideItem'), function (s) {
      return !s.classList.contains('d-none');
    });
  }

  function thumbSrc(slide) {
    // video: use its poster frame (Shopify video) or the YouTube thumbnail (external video)
    var video = slide.querySelector('video');
    if (video && video.getAttribute('poster')) return video.getAttribute('poster');
    if (slide.getAttribute('data-video-host') === 'youtube' && slide.getAttribute('data-video-id')) {
      return 'https://img.youtube.com/vi/' + slide.getAttribute('data-video-id') + '/mqdefault.jpg';
    }
    var img = slide.querySelector('img');
    if (!img) return slide.getAttribute('data-jsc-thumb') || '';
    // The theme lazy-loads: after a colour change the image may only have data-srcset (no src yet),
    // so read every place the URL can be, and remember it on the slide for the next rebuild.
    var src = img.getAttribute('data-src') || '';
    if (!src) {
      var set = img.getAttribute('data-srcset') || img.getAttribute('srcset') || '';
      if (set) src = set.split(',')[0].trim().split(' ')[0];
    }
    if (!src) src = img.getAttribute('data-original-src') || '';
    if (!src && img.currentSrc && img.currentSrc.indexOf('data:') !== 0) src = img.currentSrc;
    if (!src && img.getAttribute('src') && img.getAttribute('src').indexOf('data:') !== 0) src = img.getAttribute('src');
    src = src.replace('{width}', '200');
    if (src) slide.setAttribute('data-jsc-thumb', src);
    return src || slide.getAttribute('data-jsc-thumb') || '';
  }

  function buildThumbs() {
    if (!slider) return;
    var list = slides();
    if (!strip) {
      strip = document.createElement('div');
      strip.className = 'jsc-pdp-thumbs';
      var gallery = slider.closest('.Product__Gallery') || slider.parentNode;
      gallery.parentNode.insertBefore(strip, gallery.nextSibling);
      strip.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-thumb-index]');
        if (!btn) return;
        var f = flkty();
        if (f) f.select(parseInt(btn.getAttribute('data-thumb-index'), 10));
      });
    }
    strip.innerHTML = '';
    strip.hidden = list.length < 2;
    var seen = {};
    list.forEach(function (slide, i) {
      var alt = slide.getAttribute('data-alt') || '';
      var posInColour = seen[alt] = (seen[alt] === undefined ? 0 : seen[alt] + 1);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jsc-pdp-thumb';
      btn.setAttribute('data-thumb-index', i);
      var label = labels[posInColour] || '';
      btn.setAttribute('aria-label', label || ('Image ' + (i + 1)));
      var isVideo = /video/.test(slide.getAttribute('data-media-type') || '');
      var src = thumbSrc(slide);
      btn.innerHTML =
        '<span class="jsc-pdp-thumb__img">' +
          (src ? '<img src="' + src + '" alt="" loading="lazy">' : '') +
          (isVideo ? '<i class="jsc-pdp-thumb__play" aria-hidden="true"></i>' : '') +
        '</span>' +
        (label ? '<span class="jsc-pdp-thumb__label">' + label.replace(/</g, '&lt;') + '</span>' : '');
      strip.appendChild(btn);
    });
    markThumb();
    placeBadge();
    var f = flkty();
    if (f && !f.__jscThumbs) {
      f.__jscThumbs = true;
      f.on('change', markThumb);
      f.on('select', markThumb);
      f.on('settle', placeBadge);
    }
  }

  function markThumb() {
    if (!strip) return;
    var f = flkty();
    var i = f ? f.selectedIndex : 0;
    strip.querySelectorAll('.jsc-pdp-thumb').forEach(function (b, n) {
      b.classList.toggle('is-active', n === i);
    });
    var active = strip.querySelector('.is-active');
    if (active && strip.scrollWidth > strip.clientWidth) {
      strip.scrollTo({ left: active.offsetLeft - 16, behavior: 'smooth' });
    }
  }

  var rebuildTimer;
  function scheduleThumbs() {
    clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(buildThumbs, 150);
  }

  /* ---------- Wire up ---------- */
  /* ---------- Sticky add-to-cart bar ----------
     Appears once the main Add To Cart button has scrolled up out of view; hides again when it is back.
     Its button presses the main button, so cart/AJAX/bundle logic stays the theme's. */
  var sticky = null, currentVariant = null;
  var optionNames = data.optionNames || [];
  var colourIdx = -1;
  optionNames.forEach(function (n, i) { if (/^colou?rs?$/i.test(String(n).trim())) colourIdx = i; });

  function mainAtc() { return document.querySelector('.Product__Info .jsc-qty-atc-wrap .jsc-main-atc'); }

  function buildSticky() {
    if (sticky || !mainAtc()) return;
    sticky = document.createElement('div');
    sticky.className = 'jsc-pdp-sticky';
    sticky.setAttribute('aria-hidden', 'true');
    sticky.innerHTML =
      '<div class="jsc-pdp-sticky__inner">' +
        '<span class="jsc-pdp-sticky__img"><img alt="" data-sticky-img></span>' +
        '<span class="jsc-pdp-sticky__text">' +
          '<span class="jsc-pdp-sticky__title" data-sticky-title></span>' +
          '<span class="jsc-pdp-sticky__meta" data-sticky-meta></span>' +
        '</span>' +
        '<button type="button" class="jsc-pdp-sticky__btn" data-sticky-btn tabindex="-1">Add to cart</button>' +
      '</div>';
    document.body.appendChild(sticky);
    sticky.querySelector('[data-sticky-title]').textContent = data.title || '';
    sticky.querySelector('[data-sticky-btn]').addEventListener('click', function () {
      var btn = mainAtc();
      if (!btn) return;
      var unavailable = currentVariant && !currentVariant.available;
      if (unavailable || btn.disabled) {
        // sold out / notify-me: take the shopper to the size + colour area
        var form = document.querySelector('.Product__Info .ProductForm');
        if (form) window.scrollTo({ top: form.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
        return;
      }
      btn.click();
    });

    // show/hide on scroll past the main button
    var target = document.querySelector('.Product__Info .jsc-qty-atc-wrap') || mainAtc();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        setSticky(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(target);
    } else {
      window.addEventListener('scroll', function () { setSticky(target.getBoundingClientRect().bottom < 0); }, { passive: true });
    }
    updateSticky(currentVariant);
  }

  function setSticky(on) {
    if (!sticky) return;
    sticky.classList.toggle('is-visible', on);
    sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    sticky.querySelector('[data-sticky-btn]').tabIndex = on ? 0 : -1;
    document.body.classList.toggle('jsc-pdp-sticky-on', on);
  }

  function colourSlideSrc() {
    var col = selectedColour();
    var root = document.querySelector('.jsc-product-gallery-new-layout') || document.querySelector('.Product__Gallery');
    if (!root) return '';
    var pick = null, any = null;
    root.querySelectorAll('.Product__SlideItem').forEach(function (s) {
      if (s.querySelector('video') || /video/.test(s.getAttribute('data-media-type') || '')) return;
      if (!any) any = s;
      if (!pick && col && s.getAttribute('data-alt') === col) pick = s;
    });
    var s = pick || any;
    if (!s) return '';
    var img = s.querySelector('img');
    var src = img ? (img.getAttribute('data-src') || img.currentSrc || img.src || '') : '';
    return src.replace('{width}', '120');
  }

  function updateSticky(v) {
    if (!sticky || !v) return;
    var parts = [];
    if (colourIdx > -1 && v.options[colourIdx]) parts.push(v.options[colourIdx]);
    v.options.forEach(function (o, i) { if (i !== colourIdx && o && o !== 'Default Title') parts.push(o); });
    parts.push(v.price);
    sticky.querySelector('[data-sticky-meta]').textContent = parts.join(' · ');
    var btn = sticky.querySelector('[data-sticky-btn]');
    btn.textContent = v.available ? 'Add to cart' : 'Sold out';
    btn.classList.toggle('is-soldout', !v.available);
    var img = sticky.querySelector('[data-sticky-img]');
    var src = colourSlideSrc();
    if (src) { img.src = src; img.parentNode.hidden = false; } else { img.parentNode.hidden = true; }
  }

  function onVariant(v) {
    currentVariant = v;
    updatePrice(v);
    updateSizes(v);
    updateBadge(v);
    updateSticky(v);
  }

  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant ? byId(e.detail.variant.id) : null;
    if (v) onVariant(v);
  });

  function start() {
    onVariant(initialVariant());
    buildSticky();
    if (slider) {
      // the theme rebuilds the slider when the colour changes: rebuild the strip with it
      new MutationObserver(scheduleThumbs).observe(slider, { childList: true, subtree: false });
      var vp = slider.querySelector('.flickity-slider');
      if (vp) new MutationObserver(scheduleThumbs).observe(vp, { childList: true });
      document.addEventListener('click', function (e) {
        if (e.target.closest('.ColorSwatchList')) setTimeout(function () {
          var sl = slider.querySelector('.flickity-slider');
          if (sl && !sl.__jscObserved) { sl.__jscObserved = true; new MutationObserver(scheduleThumbs).observe(sl, { childList: true }); }
          scheduleThumbs();
        }, 400);
      });
      scheduleThumbs();
      window.addEventListener('load', scheduleThumbs);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();